import { render, staticRenderFns } from "./MailConfig.vue?vue&type=template&id=62cd5c82&"
import script from "./MailConfig.vue?vue&type=script&lang=js&"
export * from "./MailConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62cd5c82')) {
      api.createRecord('62cd5c82', component.options)
    } else {
      api.reload('62cd5c82', component.options)
    }
    module.hot.accept("./MailConfig.vue?vue&type=template&id=62cd5c82&", function () {
      api.rerender('62cd5c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/MailConfig.vue"
export default component.exports